module.exports = __webpack_public_path__ + "media/images/svg/jobs/doctor-c56396b2b9cf53dfc38c960e5dbbec88.svg";